
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.549 5.836a2.592 2.592 0 00-2.59 2.589 2.592 2.592 0 002.59 2.589 2.592 2.592 0 002.589-2.59 2.592 2.592 0 00-2.59-2.588zM7.549 12.411A2.592 2.592 0 004.959 15a2.592 2.592 0 002.59 2.589A2.592 2.592 0 0010.137 15a2.592 2.592 0 00-2.588-2.589zM7.549 18.986a2.592 2.592 0 00-2.59 2.59 2.592 2.592 0 002.59 2.588 2.592 2.592 0 002.588-2.589 2.592 2.592 0 00-2.588-2.589z","fill":"#fff","fill-opacity":".65"}}),_c('path',{attrs:{"d":"M24.069 6.493H13.466a1.934 1.934 0 00-1.931 1.932c0 1.065.866 1.931 1.931 1.931H24.07a1.934 1.934 0 001.93-1.931 1.934 1.934 0 00-1.93-1.932zM24.069 13.069H13.466A1.934 1.934 0 0011.535 15c0 1.065.866 1.931 1.931 1.931H24.07A1.934 1.934 0 0025.998 15a1.934 1.934 0 00-1.93-1.931zM24.069 19.644H13.466a1.934 1.934 0 00-1.931 1.931c0 1.065.866 1.932 1.931 1.932H24.07a1.934 1.934 0 001.93-1.932 1.934 1.934 0 00-1.93-1.931z","fill":"#fff"}})])
          )
        }
      }
    